export const SAVE_LIGIN_MSG = 'SAVE_LIGIN_MSG';
export const INIT_LOGIN_MSH = 'INIT_LOGIN_MSH';

export function saveloginInfo(data) {
  return { type: SAVE_LIGIN_MSG, data };
}

export function initloginInfo(data) {
  return { type: INIT_LOGIN_MSH, data };
}



// WEBPACK FOOTER //
// ./src/routes/routes/easyLogin/modules/actions.js